import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import coin from '@/assets/icons/coin-icn-sm.svg';
import key from '@/assets/icons/key-icn-sm.svg';
import star from '@/assets/icons/star-icn-sm.svg';
import { Button } from '@/components/Button';
import { Dialog } from '@/components/Dialogs';
import { MissionItem } from '@/components/Mission';
import { ProgressBar } from '@/components/ProgressBar';
import { missionTypes } from '@/constants/missions';
import { Missions } from '@/types/models/mission';
import { formatNumber } from '@/utils/format';

type DialogMissionProps = {
  loading: boolean;
  isOpen: boolean;
  mission: Missions | null;
  onAction: (mission?: Missions | null) => void;
  onCheck: (mission?: Missions | null) => void;
  onClose: () => void;
};

export const DialogMission = observer<DialogMissionProps>((props) => {
  const { t } = useTranslation();

  if (!props.mission) return null;

  return (
    <Dialog.Base
      isOpen={Boolean(props.isOpen)}
      onClose={props.onClose}
      canClose
    >
      <Dialog.Header>
        <Dialog.Image type="sm" src={props.mission.icon}></Dialog.Image>
        <Dialog.Title>{t(props.mission.name)}</Dialog.Title>
        <Dialog.Text>{t(props.mission.description)}</Dialog.Text>
      </Dialog.Header>
      <Dialog.Main>
        <section className="in-row-center" style={{ gap: '1rem' }}>
          {props.mission.coins && (
            <MissionItem>
              <img src={coin} style={{ width: '3rem' }} />
              <span className="in-color-secondary-contrast in-text-18">
                {`+ ${formatNumber(props.mission.coins)}`}
              </span>
            </MissionItem>
          )}
          {props.mission.keys && (
            <MissionItem>
              <img src={key} style={{ width: '3rem' }} />
              <span className="in-color-secondary-contrast in-text-18">{`+ ${formatNumber(props.mission.keys)}`}</span>
            </MissionItem>
          )}
          {props.mission.xp && (
            <MissionItem>
              <img src={star} style={{ width: '3rem' }} />
              <span className="in-color-secondary-contrast in-text-18">{`+ ${formatNumber(props.mission.xp)}`}</span>
            </MissionItem>
          )}
        </section>
        {props.mission.type === missionTypes.quest && (
          <ProgressBar
            width={Number(
              ((props.mission.done / props.mission.target) * 100).toFixed(0),
            )}
            title={props.mission.title}
            topProgress={`${props.mission.done}/${props.mission.target}`}
          />
        )}
      </Dialog.Main>
      <Dialog.Footer className="in-col-center" style={{ gap: '1rem' }}>
        {!(props.mission.type === missionTypes.custom) && (
          <Button onClick={() => props.onAction(props.mission)}>
            {t(props.mission.action)}
          </Button>
        )}
        <Button
          loading={props.loading}
          onClick={() => props.onCheck(props.mission)}
          type="secondary"
        >
          {t('dialogs.mission.action')}
        </Button>
      </Dialog.Footer>
    </Dialog.Base>
  );
});
